module.exports = __webpack_public_path__ + "867618ab1ff5761554eeca8abd45e193.MP3";